import React, { useCallback, useEffect, useState } from 'react';
import { Download, RefreshCw, Search, Trash2 } from 'lucide-react';
import Loader from '../Loader';
import { WarningVideos } from './UpUserPanel';
import { Badge, Confirm, Empty, HScroll, Pager, Status } from './UpUi';
import { dateTime } from './format';

/**
 * Comportement suspect (vidéos débloquées à la chaîne) : tous les avertissements, du plus récent au plus ancien.
 * « Télécharger le JSON » : le fichier complet (5000 derniers).
 */
const UpWarnings = ({ pApi, project, onOpen, notify, reloadKey, onChanged }) => {
    const [page, setPage] = useState(1)
    const [search, setSearch] = useState('')
    const [q, setQ] = useState('')
    const [data, setData] = useState(null)
    const [error, setError] = useState('')
    const [confirm, setConfirm] = useState(null)

    const load = useCallback(async () => {
        setError('')
        try { setData(await pApi.get('/warnings', { page, perPage: 25, ...(q && { q }) })) } catch (e) { setError(e.message) }
    }, [pApi, page, q])
    useEffect(() => { load() }, [load, reloadKey])
    useEffect(() => {
        const t = setTimeout(() => { setQ(search.trim()); setPage(1) }, 350)
        return () => clearTimeout(t)
    }, [search])

    const download = async () => {
        try {
            const all = await pApi.get('/warnings', { all: '1' })
            const blob = new Blob([JSON.stringify(all.items, null, 2)], { type: 'application/json' })
            const a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = `suspects-${project}-${new Date().toISOString().slice(0, 10)}.json`
            a.click()
            URL.revokeObjectURL(a.href)
        } catch (e) { notify(e.message, true) }
    }

    const del = (w) => setConfirm({
        title: 'Effacer cet avertissement',
        text: `Effacer l'avertissement de ${w.email} ? Il ne comptera plus pour le blocage automatique.`,
        action: 'Effacer',
        onConfirm: async () => {
            try { await pApi.del(`/warnings/${w.id}`); notify('Avertissement effacé'); load(); onChanged() } catch (e) { notify(e.message, true) }
        },
    })

    return (
        <div>
            <div className='up-toolbar'>
                <div className='up-search'>
                    <Search size={16} />
                    <input placeholder='Email…' value={search} onChange={(e) => setSearch(e.currentTarget.value)} />
                </div>
                <button className='btn cw up-icon-btn' onClick={load} title='Actualiser'><RefreshCw size={15} /></button>
                <button className='btn cs' onClick={download}><Download size={15} /> Télécharger le JSON</button>
            </div>
            <p className='up-hint'>Un avertissement = plusieurs nouvelles vidéos débloquées coup sur coup (réglages : nomenclature.json → suspect). Au 3e, le compte est bloqué automatiquement.</p>
            {error && <p className='up-error'>{error}</p>}
            {!data && !error ? <div className='up-loading'><Loader /></div> : data && (
                <>
                    <p className='up-count'><b>{data.total}</b> avertissement{data.total > 1 ? 's' : ''}</p>
                    <HScroll>
                        <div className='up-table up-table-allwarnings'>
                            <div className='up-thead'><span>Date</span><span>User</span><span>Vidéos ouvertes à la chaîne</span><span>IP</span><span></span></div>
                            {data.items.map((w) => (
                                <div key={w.id} className='up-row' onClick={() => onOpen(w.userId)}>
                                    <span>{dateTime(w.createdAt)}</span>
                                    <span className='up-user'>
                                        <span className='truncate' title={w.email}>{w.email}</span>
                                        <span className='up-badges'><Status status={w.status} /><Badge tone='warn'>{w.userWarnings} avert.</Badge></span>
                                    </span>
                                    <WarningVideos w={w} />
                                    <span className='up-muted'>{w.ip || '—'}</span>
                                    <span className='tar' onClick={(e) => e.stopPropagation()}>
                                        <button className='pay-act-btn' title='Effacer' onClick={() => del(w)}><Trash2 size={15} color='#f71717' /></button>
                                    </span>
                                </div>
                            ))}
                            {!data.items.length && <Empty>Aucun avertissement</Empty>}
                        </div>
                    </HScroll>
                    <Pager page={data.page} pages={data.pages} onPage={setPage} />
                </>
            )}
            {confirm && <Confirm {...confirm} onClose={() => setConfirm(null)} />}
        </div>
    )
}

export default UpWarnings;
